import accessToken from 'utils/accessToken';
import { isProductionEnv } from 'utils/general';

import auth from './auth';
import dashboard from './dashboard';
import deviceConfig from './device-config';
import deviceProfiles from './device-profiles';
import flows from './flows';
import general from './general';
import IPNetwork from './ip-networks';
import OrganizationUsers from './organization-users';
import organizations from './organizations';
import SCHCTemplates from './schc-templates';
import search from './search';
import sources from './sources';
import users from './users';

export function buildURI(uri: string, apiVersion = '') {
  let prefix = '';
  let prefixAPIVersion = '';
  if (!isProductionEnv()) {
    prefix = '/backend';
  }
  if (apiVersion) {
    prefixAPIVersion = `/api/${apiVersion}`;
  }
  return `${prefix}${prefixAPIVersion}${uri}`;
}

export function buildRequest(method: string, uri: string, params: any = null) {
  return fetch(
    buildURI(uri, 'v2'),
    {
      method,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Grpc-Metadata-auth-token': accessToken.get() as string,
      },
      body: params ? JSON.stringify(params) : null,
    },
  );
}

export function buildFileUploadRequest(method: string, uri: string, file: File) {
  const data = new FormData();
  data.append('upload-file', file, file.name);

  return fetch(
    buildURI(uri, 'v2'),
    {
      method,
      credentials: 'same-origin',
      headers: {
        'Grpc-Metadata-auth-token': accessToken.get() as string,
      },
      body: data,
    },
  );
}

export type PaginationT = {
  cursor: number;
  limit: number;
}

export type APICallParams = {
  flowId?: string;
  deviceProfileId?: string;
  search?: string;
}

/* eslint-disable */
export interface APIInterfaceI {
  getAll: (pagination: PaginationT, params?: APICallParams) => Promise<Response>;
  getOne: (targetId: string, params?: APICallParams) => Promise<Response>;
  delete: (targetId: string, params?: APICallParams) => Promise<Response>;
  update: (targetId: string, formData: any, params?: APICallParams) => Promise<Response>;
  register: (formData: any, params?: APICallParams) => Promise<Response>;
}

export interface APIInterfaceWithActiveStatusI extends APIInterfaceI {
  setActivateStatus: (userId: string, newStatus: boolean) => Promise<Response>; // eslint-disable-line
}

export default {
  sources: new sources(),
  organizations: new organizations(),
  flows: new flows(),
  deviceProfiles: new deviceProfiles(),
  deviceConfig: new deviceConfig(),
  IPNetwork: new IPNetwork(),
  SCHCTemplates: new SCHCTemplates(),
  general: new general(),
  auth,
  users: new users(),
  OrganizationUsers: OrganizationUsers,
  dashboard: new dashboard(),
  search: new search(),
};
